export function fromEntries(iterable: $TSFixMe) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

const isValidHexColor = (color?: string) =>
  color && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);

export const getValidHexColor = (color?: string) =>
  color && isValidHexColor(color) ? color : undefined;
